import React, { Component } from "react";
import { formatApiError } from "../constants/apiErrorMessages";
import { FRONTEND_ORIGIN_URL_NO_SLASH } from "../config";
import withTracker from "./withtracker";
import AuthorizationHOC from "./AuthorizationHOC";
import { REGISTERED_USERS } from "../constants/userGroups";
import MetaData from "../components/meta/meta";
import SectionStart from "../components/sectionStart/sectionStart";
import {
  Sidebar,
  SidebarHeader,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../components/layouts/layout1";
import Title from "../components/title/title";
import Heading from "../components/heading/heading";
import * as actions from "../actions";
import { connect } from "react-redux";
import { getRouteUrl } from "../routers";
import {
  ROUTE_ORGANIZATION_CREATE,
  ROUTE_ORGANIZATION_VIEW_SINGLE,
} from "../routers/content/organization";
import OrganizationForm from "../components/organization/organizationForm/organizationForm";
import FaSpinner from "../components/faSpinner/faSpinner";
import ErrorMessage from "../components/errorMessage/errorMessage";
import withBreadCrumb from "./withBreadcrumb";

class OrganizationCreateHOC extends Component {
  onSubmit = (evt) => {
    const payload = {
      uuid: evt.uuid,
      title: evt.title,
      description: evt.description,
      image: evt.image,
      redirectAfterUpdate: getRouteUrl(ROUTE_ORGANIZATION_VIEW_SINGLE, {
        organizationId: evt.uuid,
      }),
    };
    this.props.createOrganization(payload);
  };

  componentDidMount() {
    // Clear any existing errors and form state when component mounts
    this.props.clearOrganizationForm();
  }

  render() {
    const { loading, error } = this.props;

    // Format error message from API response
    const errorMessage =
      error && error.exception
        ? formatApiError(error.exception)
        : typeof error === "object"
        ? JSON.stringify(error)
        : error;

    return (
      <div>
        <MetaData
          title="Edit Organization"
          url={
            FRONTEND_ORIGIN_URL_NO_SLASH +
            getRouteUrl(ROUTE_ORGANIZATION_CREATE)
          }
        />

        <SectionStart>
          <SideBar>
            <SidebarLeft>
              <SidebarHeader>
                <Title type="section" displayEffect>
                  <Heading level="1">CREATE ORGANIZATION</Heading>
                </Title>
              </SidebarHeader>
            </SidebarLeft>
            <SidebarRight>
              <div>
                {errorMessage && (
                  <ErrorMessage
                    message={errorMessage}
                    style={{ marginBottom: 20 }}
                  />
                )}

                <OrganizationForm onSubmit={this.onSubmit} loading={loading} />

                {loading && <FaSpinner loading />}
              </div>
            </SidebarRight>
          </SideBar>
        </SectionStart>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.organizationFormReducer?.loading,
  error: state.organizationFormReducer?.errors?.createOrganization,
});

const mapDispatchToProps = (dispatch) => ({
  clearOrganizationForm: (payload) => {
    dispatch(actions.clearOrganizationForm(payload));
  },
  createOrganization: (payload) => {
    dispatch(actions.createOrganization(payload));
  },
});

export default withTracker(
  AuthorizationHOC(REGISTERED_USERS)(
    withBreadCrumb(
      connect(mapStateToProps, mapDispatchToProps)(OrganizationCreateHOC),
      {
        name: "Create",
        parents: ["Organizations"],
      }
    )
  )
);
